import { graphql, Link } from "gatsby"
import Img from "gatsby-image"
import React from "react"
import ReactMarkdown from "react-markdown"
import styled from "styled-components"
import Footer from "../components/Footer"
import Heading from "../components/Heading"
import Layout from "../components/Layout"
import Navbar from "../components/Navbar"
import SEO from "../components/SEO"
import Button from "../components/main-page/Button"
import { device } from "../utils/device"
import remarkGfm from "remark-gfm";
import rehypeRaw from "rehype-raw";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 75%;
  min-height: calc(100vh - 647px);
  max-width: 1000px;
  margin: 0 auto;
  color: ${props => props.theme.colors.text.gray};

  @media ${device.laptop} {
    height: 100%;
    width: 100%;
    padding: 50px 100px;
    min-height: 0;
  }
  @media ${device.tablet} {
    padding: 30px;
  }
  @media ${device.mobileM} {
    padding: 20px;
  }

  h1,
  h2,
  h3,
  h4 {
    color: ${props => props.theme.colors.mediumBlue};
    margin: 30px 0 20px 0;
    @media ${device.laptop} {
      height: 100%;
      width: 100%;
      font-size: 20px;
    }
  }

  h3 {
    font-size: 20px;
  }

  p, a, li, td, th {
    font-size: 17px;
    line-height: 28px;
  }
  p {
    margin-bottom: 20px;
  }

  a {
    color: ${props => props.theme.colors.darkOrange};
  }

  ul, ol {
    list-style: none;
    padding-left: 35px;

    li {
      &:before {
        background: ${props => props.theme.colors.background.orangeGradient};
        float: left;
        margin: 4px 0 0 -35px;
      }
      align-items: center;
      margin-bottom: 24px;
    }
  }

  ul {
    @media ${device.laptop} {
      height: 100%;
      width: 100%;
      font-size: 14px;
    }

    li {
      &:before {
        content: "";
        height: 15px;
        width: 15px;
      }
    }
  }

  ol {
    counter-reset: item;
    li {
      counter-increment: item;
      &:before {
        content: counter(item);
        border-radius: 100%;
        color: ${props => props.theme.colors.white};
        height: 1.6em;
        width: 1.6em;
        text-align: center;
        display: inline-block;
      }
    }
  }

  strong {
    color: ${props => props.theme.colors.mediumBlue};
  }

  h1:last-child,
  h2:last-child,
  h3:last-child,
  h4:last-child,
  ul:last-child,
  ol:last-child,
  p:last-child {
    margin-bottom: 0;
  }
`

const Image = styled.div`
  margin: 0 auto;
  max-height: 500px;

  img {
    max-width: 100%;
    max-height: 500px;
  }
`;

const Content = styled.div`
`;

const CTA = styled.div`
  margin: 50px auto 20px;
`;

function ArticlePageTemplate(props) {
  const { title, content, description, image, slug, tags } = props.pageContext

  return (
    <Layout>
      <SEO
        title={title}
        description={description}
        og_title={title}
        og_description={description}
        og_image_url={image}
        tags={tags}
      />
      <Navbar dark="true" />
      <Heading title={title} />
      <Container>
        <Image>
            <img src={image} alt={title} />
        </Image>
        <Content>
          <ReactMarkdown remarkPlugins={[remarkGfm]} rehypePlugins={[rehypeRaw]}>{content}</ReactMarkdown>
        </Content>
        <CTA>
            <Link to='/book-discovery-call'>
            <Button>Lean More</Button>
            </Link>
        </CTA>
      </Container>
      <Footer />
    </Layout>
  )
}

export default ArticlePageTemplate
